<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<!--page-->
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-heading-health-family"></div>
      <div class="card-body">
        <h3 class="title">هشتگ بیمه، دستیار شخصی بیمه</h3>
        <br>
        <div>
          <p>
            برای پیگیری وضعیت درخواست بیمه موبایل شماره همراه خود و کد پیگیری را وارد نمایید
            <br>
          </p>
          <br>
          <app-input-field [dataType]="['text', 11]" [Icon]="true" [fieldLabel]="'شماره همراه'" [fieldName]="'mobile'"
                           [Group]="loginForm">
          </app-input-field>
          <app-input-field [dataType]="['text']" [Icon]="true" [fieldLabel]="'کد پبگبری'" [fieldName]="'requestToken'"
                           [Group]="loginForm">
          </app-input-field>
          <br>
          <br>
          <div class="col-md-12">
            <button type="button" [disabled]="!loginForm.valid" (click)="getRequestID()" class="btn btn-primary pull-left">ادامه</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
